import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Multiselect extends Vue {

  // Valores posibles
  @Prop({ default: () => [] }) values;
  // Nombre de la propiedad a mostrar
  @Prop({ default: 'name' }) displayValue;
  @Prop({ default: '' }) selectedValue;
  // Si se establece un valor inicial
  @Prop({ default: true }) setDefaultValue;
  // Valor de la propiedad del valor inicial
  @Prop({ default: "" }) defaultValue;
  // Mensaje en caso de no haber seleccionado una opción
  @Prop({ default: '' }) placeholder;

  @Prop({ default: true }) isRounded;
  @Prop({ default: false }) isError;

  openSelector = false;
  currentOption = null;

  get getPlaceHolder() {
    let response = "Selecciona una opción";
    if(this.placeholder) {
      response = this.placeholder;
    }
    return response;
  }

  mounted() {
    this._setDefaultValue();
  }

  _setDefaultValue() {
    let value = null;
    if (
      this.defaultValue &&
      this.defaultValue.length &&
      this.setDefaultValue &&
      this.values &&
      this.values.length
    ) {
      if(this.displayValue) {
        value = this.values.find(
          (item) => item[this.displayValue] == this.defaultValue
        );
      } else {
        value = this.values.find(
          (item) => item == this.defaultValue
        );
      }
    } else {
      value = this.values[0];
    }
    this.setCurrentValue(value);
  }

  getValue(option) {
    let response = "";
    if(option && this.displayValue && option[this.displayValue]) {
      response = option[this.displayValue];
    } else if (option && !this.displayValue) {
      response = option;
    }
    return response;
  }

  getSelectedValue() {
    let response = "";
    if(this.selectedValue && this.selectedValue.length) {
      response = this.currentOption[this.selectedValue];
    } else {
      response = this.getValue(this.currentOption);
    }
    return response;
  }

  setCurrentValue(option) {
    if(option) {
      this.currentOption = option;
      this.openSelector = false;
      this.$emit('onSelect', option);
    }
  }

  isCurrentOption(option) {
    let response = false;
    if (
      option &&
      option[this.displayValue] &&
      this.currentOption &&
      this.currentOption[this.displayValue] &&
      option[this.displayValue] == this.currentOption[this.displayValue]
    ) {
      response = true;
    }
    return response;
  }
}
